class CountdownTimer extends HTMLElement {
	constructor() {
		super();
		this.timerDisplay = null;
		
		// Get the end time from the data attribute
		const endTimeString = this.getAttribute('data-time');
		
		// Get store timezone from Shopify (fallback to UTC if not available)
		this.storeTimezone = 'America/New_York';
		
		// Parse the end time as a Date object
		this.endTime = new Date(endTimeString);
		
        this.colorScheme = this.getAttribute('data-color-scheme') || 'red';

        // Check if the end time has already passed using store timezone
        const nowInStoreTimezone = this.getCurrentTimeInStoreTimezone();
        if (nowInStoreTimezone >= this.endTime) {
            this.remove();
        }
	}

	connectedCallback() {
		// Check if the end time is in the past using store timezone
		const nowInStoreTimezone = this.getCurrentTimeInStoreTimezone();
		if (nowInStoreTimezone >= this.endTime) {
			this.style.display = 'none';
			return;
		}

		this.style.display = 'inline-block';

		// Create a span to show the countdown
		this.timerDisplay = document.createElement('span');

        let textColorClass = 'text-primary-900';

        //switch case for the color scheme
        switch (this.getAttribute('data-color-scheme')) {
            case 'gold':
                textColorClass = 'sm:text-warning-900';
                break;
            case 'dark':
                textColorClass = 'sm:text-dark-900';
                break;
            case 'green':
                textColorClass = 'sm:text-green-900';
                break;
            default:
                textColorClass = 'sm:text-red-900';
                break;
        }

		this.timerDisplay.className = `font-bold sm:bg-white ${textColorClass} sm:px-1.5 sm:py-0.5 sm:rounded sm:mx-0.5`; // Tailwind CSS classes
		this.appendChild(this.timerDisplay);

		// Start the countdown
		this.updateCountdown();
		this.interval = setInterval(() => this.updateCountdown(), 1000);
	}

	disconnectedCallback() {
		//remove the timerDisplay
		this.removeChild(this.timerDisplay);
		// Clear the interval when the element is removed from the DOM
		clearInterval(this.interval);
	}

	// Helper method to get current time in store timezone
	getCurrentTimeInStoreTimezone() {
		const now = new Date();
		
		// If we have a valid timezone, convert to store timezone
		if (this.storeTimezone && this.storeTimezone !== 'UTC') {
			try {
				// Get the current time in the store's timezone
				const storeTime = new Date(now.toLocaleString('en-US', { timeZone: this.storeTimezone }));
				return storeTime;
			} catch (error) {
				console.warn('Error converting to store timezone:', error);
				// Fallback to current time
				return now;
			}
		}
		
		// Fallback to current time if no timezone conversion possible
		return now;
	}

	updateCountdown() {
		const nowInStoreTimezone = this.getCurrentTimeInStoreTimezone();
		const timeRemaining = this.endTime - nowInStoreTimezone;

		// If the time has passed, hide the countdown element and clear the interval
		if (timeRemaining <= 0) {
			this.style.display = 'none';
			clearInterval(this.interval);
			return;
		}

		// Calculate days, hours, minutes, and seconds
		const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

		// Display the result in the countdown element
		this.timerDisplay.innerHTML = `
        <span>${days}</span><span class="text-xs">d</span> 
        <span>${hours}</span><span class="text-xs">h</span> 
        <span>${minutes}</span><span class="text-xs">m</span> 
        <span>${seconds}</span><span class="text-xs">s</span>`;
	}
}

// Define the custom element
customElements.define('countdown-timer', CountdownTimer);

console.log('countdown active');
